import Transactions from "./pages/Transactions/Transactions";
import Dashboard from "./pages/dashboard/Dashboard";
import Settlement from "./pages/settlement/Settlement";
import { Login } from "@rewardle/apps.ui.login.login";
import { Forgotpassword } from "@rewardle/apps.ui.forgotpassword.forgotpassword";
import { Signupprocess } from "@rewardle/apps.ui.signup.signupprocess";
import { Unauthorisedlayout } from "@rewardle/apps.auth.unauthorisedlayout.unauthorisedlayout";
import Staffs from "./pages/staff/Staffs";
import StaffDetails from "./pages/staff/StaffDetails";
import PaymentDetails from "./pages/paymentDetails/PaymentDetails";
import AddCreditCard from "./pages/addCreditCard/AddCreditCard";
import MembersPage from "./pages/Members/MembersPage";
import MemberDetailsPage from "./pages/Members/MemberDetailsPage";
import ManageRewards from "./pages/rewards/ManageRewards";
import ManagePrograms from "./pages/programs/ManagePrograms";
import ProfilePage from "./pages/account/profile/ProfilePage";
import JoinQRCode from "./pages/joinQRCode/JoinQRCode";
import EmailCampaigns from "./pages/emailCampaigns/EmailCampaigns";
import CreateEmailCampaign from "./pages/emailCampaigns/CreateEmailCampaign";
import EditEmailCampaign from "./pages/emailCampaigns/EditEmailCampaign";
import CardManagement from "./pages/cardManagement/CardManagement";
import CreditCard from "./pages/cardManagement/CreditCard";
import DebitCard from "./pages/cardManagement/DirectDebit";
import ChangePasswordPage from "./pages/account/changePassword/ChangePasswordPage";

const actionCodeSettings = {
  url: `${process.env.REACT_APP_API_URL}`,
  handleCodeInApp: true,
  dynamicLinkDomain: process.env.REACT_APP_DYNAMIC_LINK_DOMAIN
};

export const authedRoutes = [
  {
    path: "/",
    element: <Dashboard />
  },
  {
    path: "dashboard",
    element: <Dashboard />
  },
  {
    path: "transactions",
    element: <Transactions />
  },
  {
    path: "settlements",
    element: <Settlement />
  },
  {
    path: "staffs",
    element: <Staffs />
  },
  {
    path: "staff",
    element: <StaffDetails />
  },
  {
    path: "staff/:id",
    element: <StaffDetails />
  },
  {
    path: "/account/paymentdetails",
    element: <PaymentDetails />
  },
  {
    path: "/account/credit-card",
    element: <AddCreditCard />
  },
  {
    path: "/card",
    element: <CardManagement />
  },
  {
    path: "/card/credit",
    element: <CreditCard />
  },
  {
    path: "/card/debit",
    element: <DebitCard />
  },
  {
    path: "/members",
    element: <MembersPage />
  },
  {
    path: "/members/:userId",
    element: <MemberDetailsPage />
  },
  {
    path: "/rewards",
    element: <ManageRewards />
  },
  {
    path: "/program",
    element: <ManagePrograms />
  },
  {
    path: "/joinqrcode",
    element: <JoinQRCode />
  },
  {
    path: "/account/account",
    element: <ProfilePage />
  },
  {
    path: "/account/changepwd",
    element: <ChangePasswordPage />
  },
  {
    path: "/emailcampaigns",
    element: <EmailCampaigns />
  },
  {
    path: "/emailcampaigns/create",
    element: <CreateEmailCampaign />
  },
  {
    path: "/emailcampaigns/duplicate/:campaignId",
    element: <CreateEmailCampaign />
  },
  {
    path: "/emailcampaigns/edit/:campaignId",
    element: <EditEmailCampaign />
  }
];

export const unAuthedRoutes = [
  {
    path: "/",
    element: (
      <Login
        authorizationName={"BusinessAuthorization"}
        apiDomain={process.env.REACT_APP_API_BASE_MENU_URL}
      />
    )
  },
  {
    path: "login",
    element: (
      <Login
        authorizationName={"BusinessAuthorization"}
        apiDomain={process.env.REACT_APP_API_BASE_MENU_URL}
      />
    )
  },
  {
    path: "forgot-password",
    element: (
      <Forgotpassword
        actionCodeSettings={actionCodeSettings}
        authorizationName={"BusinessAuthorization"}
      />
    )
  },
  {
    path: "get-started",
    element: <Signupprocess />
  }
];

export const unAuthorisedlayout = [
  {
    path: "/",
    element: <Unauthorisedlayout />
  },
  {
    path: "unauthorised",
    element: <Unauthorisedlayout />
  }
];
